export default __webpack_public_path__ + "static/media/URS.0429c210.png";